var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.381,
    viewBox: "0 0 20 20.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00095b;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Driver-Assistance",
    transform: "translate(-11.221 -10.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DriverAssistance_Auto_Active_ParkAssist_48",
    "data-name": "DriverAssistance/Auto(Active)ParkAssist/48",
    transform: "translate(11.221 10.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Auto_Active_ParkAssist",
    "data-name": "Auto(Active)ParkAssist",
    className: "cls-1",
    d: "M21.223,10.54a10.192,10.192,0,1,1-10,10.19A10.1,10.1,0,0,1,21.223,10.54Zm7.546,11.646H25.734a.694.694,0,0,0-.635.4,4.347,4.347,0,0,1-2.059,2.1.708.708,0,0,0-.389.646h0v3.095a.718.718,0,0,0,.9.706A8.651,8.651,0,0,0,29.462,23.1a.725.725,0,0,0-.693-.917Zm-12.058,0H13.675a.726.726,0,0,0-.694.917,8.655,8.655,0,0,0,5.914,6.025.718.718,0,0,0,.9-.706h0V25.327a.711.711,0,0,0-.389-.646,4.34,4.34,0,0,1-2.062-2.1.689.689,0,0,0-.632-.4Zm4.511-2.911a1.456,1.456,0,1,0,1.428,1.456A1.442,1.442,0,0,0,21.223,19.275Zm0-7.279a8.593,8.593,0,0,0-8.243,6.365.725.725,0,0,0,.694.914h3.038a.7.7,0,0,0,.634-.4,4.246,4.246,0,0,1,7.752,0,.7.7,0,0,0,.636.4H28.77a.724.724,0,0,0,.693-.914A8.59,8.59,0,0,0,21.223,12Z",
    transform: "translate(-11.221 -10.54)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolante);
export default __webpack_public_path__ + "static/media/volante.82417fcad5b65e11ec65123ba77d8cb2.svg";
export { ForwardRef as ReactComponent };